// extracted by mini-css-extract-plugin
export default {"recommendedCard":"style_recommendedCard__m-K6N","add_anim":"style_add_anim__IGaRa","removeCardAnimation":"style_removeCardAnimation__K9wCH","remove_anim":"style_remove_anim__AjA1A"};